export var EOAWallets;
(function (EOAWallets) {
    EOAWallets["COINBASE_WALLET"] = "com.coinbase.wallet";
    EOAWallets["METAMASK"] = "io.metamask";
    EOAWallets["WALLET_CONNECT"] = "WalletConnect";
})(EOAWallets || (EOAWallets = {}));
//# sourceMappingURL=types.js.map